export default __webpack_public_path__ + "static/media/photo2.96019b90.png";